export default __webpack_public_path__ + "static/9-572ac16c35ddda01638c6b42d20169b4.jpg";